export type NewStyleErrorType = {
  error_message: string;
  error_code: string;
};

export type ValidationErrorDetailType = {
  loc: (string | number)[];
  msg: string;
  type: string;
};

export type ErrorType = {
  code?: string;
  message?: string;
  response?: {
    data?: {
      detail?: string | NewStyleErrorType | ValidationErrorDetailType[];
    };
    status?: number;
  };
};

export const errorStrings = {
  something_went_wrong: "Something went wrong, please try again.",
};

export const getValidationErrorMessages = (
  errors: ValidationErrorDetailType[]
): string => {
  return errors
    .map((err) => `${err.loc.slice(1).join(" --> ")}: ${err.msg}`)
    .join(", \n");
};

export const getErrorMessage = (
  error: string | NewStyleErrorType | ValidationErrorDetailType[] | undefined
) => {
  if (!error) {
    return errorStrings.something_went_wrong;
  }
  if (typeof error === "string") {
    return error;
  }
  if (
    typeof error === "object" &&
    error !== null &&
    "error_message" in error &&
    typeof error.error_message === "string"
  ) {
    return error.error_message;
  }
  if (Array.isArray(error) && error.length > 0) {
    return getValidationErrorMessages(error);
  }
  return errorStrings.something_went_wrong;
};

export const isUserAbortedError = (error: unknown) => {
  return (error as { code?: string })?.code === "ERR_CANCELED";
};

export const extractErrorMessage = (error: unknown) => {
  if (isUserAbortedError(error)) {
    return null;
  }
  const axiosError = error as ErrorType;
  return (
    getErrorMessage(axiosError?.response?.data?.detail) ||
    axiosError?.message ||
    errorStrings.something_went_wrong
  );
};
